// @flow
import React from 'react';
import ProductsTagItem from 'components/tags/ProductsTagItem';
import { type ProductsTagData } from 'store/modules/common';
import './ProductsTagItemList.scss';

type Props = {
  tags: ?(ProductsTagData[]),
  onSelectTag: (info: any) => void,
};

const ProductsTagItemList = ({ tags, onSelectTag }: Props) => {
  if (!tags) return null;
  const tagList = tags.map(({ name, products_count: productsCount }) => (
    <ProductsTagItem name={name} count={productsCount} key={name} onClick={onSelectTag} />
  ));
  return <div className="ProductsTagItemList">{tagList}</div>;
};

export default ProductsTagItemList;



// WEBPACK FOOTER //
// ./src/components/tags/ProductsTagItemList/ProductsTagItemList.js